import { ReactNode } from 'react';

import { FeatureFlagEnum } from '../types';

import { useFeatureFlags } from './hook';

type FeatureToggleProps = {
  flag: FeatureFlagEnum;
  defaultValue?: boolean;
  children: ReactNode;
  fallback?: ReactNode;
};

export const FeatureToggle = ({
  flag,
  defaultValue = false,
  children,
  fallback = null,
}: FeatureToggleProps) => {
  const { checkFeature } = useFeatureFlags();
  const enabled = checkFeature(flag, defaultValue);
  return enabled ? <>{children}</> : <>{fallback}</>;
};
